import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import store from './store';
import { Provider } from 'react-redux';

// import {
//   BrowserRouter as Router,
//   Routes,
//   Route
// } from "react-router-dom";

import {BrowserRouter} from 'react-router-dom';

import { getLoginAPIURL } from '../src/utiles';

const Confdata = getLoginAPIURL();

;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Provider store={store}>
    <App/>
  </Provider>
  </BrowserRouter>
);


